import { render, staticRenderFns } from "./VenueChooser.vue?vue&type=template&id=72e38979&"
import script from "./VenueChooser.vue?vue&type=script&lang=js&"
export * from "./VenueChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports